export default {"src":"/login-app/[GIT_HASH]/_next/static/media/checkbox_intermediate.c8b87298.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};